import APIService from '../api.service';

export const FetchRoleList = (payload) => {
  return APIService.get(`/v01/roles`, {
    params: {
      ...payload
    },
  });
};

export const FetchRoleDetails = (id, config = {}) => {
    return APIService.get(`/v01/rolses/${id}`, config);
};

export const CreateRole = (body, config = {}) => {
  return APIService.post(`/v01/roles`, body, config);
};

export const UpdateRole = (payload) => {
  const id = payload.id;
    return APIService.put(`/v01/roles/${id}`, {
            ...payload
    });
  };

export const DeleteRole = (id) => {
    return APIService.delete(`/v01/roles/${id}`);
  };


const RoleService = {
 FetchRoleList,
 FetchRoleDetails,
 CreateRole,
 UpdateRole,
 DeleteRole
};

export default RoleService;
